module.exports = __webpack_public_path__ + "img/line-bg.78d3c531.png";